import classnames from 'classnames';

interface IHeroHexagonProps {
  text: string;
  iconClass: string;
}

const HeroHexagon = ({ iconClass, text }: IHeroHexagonProps) => (
  <div className="hexagon-wrapper">
    <div className={classnames('hexagon', iconClass)} />
    <span>{text}</span>
  </div>
);
export default HeroHexagon;
